import React, { Component } from 'react';
import { connect } from 'react-redux';

import { jsDictionaryEquals } from '../../../../../../../../ressources/functionJS/jsDictionaryEquals';
import styles from './TexteRapport.module.scss';
import * as actions from '../../../../../../../../services/actions';
import Collapse from '../../../../../../../../hoc/Collapse/Collapse';

class TexteRapport extends Component {
  constructor(props) {
    super(props);
    this.state = this.initializeStateFromProps(props);
  }

  // Initialize or update state from props
  initializeStateFromProps = (props) => {
    return { ...(props.preconfigureObjet || {}) };
  };

  // Update state when props change
  updateStateFromProps = () => {
    this.setState(this.initializeStateFromProps(this.props));
  };

  // Handle input changes
  handleInputChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value }, () => {
      // Notify parent component about state changes
      if (this.props.gererJson) {
        this.props.gererJson(this.state);
      }
    });
  };

  componentDidMount() {
    // Initial state already set in constructor
  }

  componentDidUpdate(prevProps, prevState) {
    const { preconfigureObjet } = this.props;

    // Vérification des changements dans preconfigureObjet
    if (
      prevProps.preconfigureObjet !== preconfigureObjet &&
      !jsDictionaryEquals(prevProps.preconfigureObjet, preconfigureObjet)
    ) {
      this.updateStateFromProps();
    }

    // Notification au composant parent si l'état a changé
    if (!jsDictionaryEquals(prevState, this.state)) {
      this.props.gererJson(this.state);
    }
  }

  render() {
    const { contenuEnTete, children, affichageProfil } = this.props;
    const { text } = this.state;

    return (
      <Collapse
        expandText={
          <div className={styles.contenuEnTete}>
            {contenuEnTete}
            <span className={styles.titre}>{text}</span>
          </div>
        }
      >
        {children}
        <input
          className={styles.Input}
          type="text"
          name="text"
          value={text}
          disabled={affichageProfil === true}
          onChange={this.handleInputChange}
        />
      </Collapse>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  reqCreerRapportGabarit: (formulaireRapportGabarit) =>
    dispatch(actions.reqCreerRapportGabarit(formulaireRapportGabarit)),
  reqModifierRapportGabarit: (formulaireRapportGabarit) =>
    dispatch(actions.reqModifierRapportGabarit(formulaireRapportGabarit)),
});

export default connect(null, mapDispatchToProps)(TexteRapport);
